import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Configuration from 'redpoints-connector-common/helper/Configuration';

import {
  Button,
  Col,
  Paper,
  Radio,
  Row,
  TreeSelector,
} from 'redpoints-front-components/index';
import { withContext } from 'redpoints-front-common/components';

import {
  getDomainPlatform,
  getDomainsIdFromTree,
} from '../../../containers/Tasks/ReportedIncidents/ReportedIncidentsHelper';
import { translate } from '../../../helpers/languageHelper';

import './reportedIncidents.less';

const DEFAULT_STATE = {
  domainIds: [],
  domainsPlatformList: [],
  isEnableFilterByTenant: false,
  resultsFilteredBy: true,
};

class ReportedIncidentsFilters extends PureComponent {
  constructor(props) {
    super(props);
    this.state = DEFAULT_STATE;

    this.getConfiguration = this.getConfiguration.bind(this);
    this.handleChangeDomain = this.handleChangeDomain.bind(this);
    this.handleChangeFilterByCustomer = this.handleChangeFilterByCustomer.bind(
      this
    );
    this.initFilters = this.initFilters.bind(this);
    this.onApplyFilters = this.onApplyFilters.bind(this);
    this.onClearFilters = this.onClearFilters.bind(this);
  }

  async componentDidMount() {
    await this.getConfiguration();
    await this.initFilters();
  }

  async componentDidUpdate({ shouldRefreshFilters }) {
    if (shouldRefreshFilters) {
      await this.initFilters();
    }
  }

  async getConfiguration() {
    try {
      const configuration = await Configuration.getJSONConfig();
      this.setState({
        isEnableFilterByTenant:
          configuration.task?.enableFilterByTenant ?? false,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  async initFilters() {
    const {
      context,
      customer: { customerId },
    } = this.props;

    const { resultsFilteredBy } = this.state;

    const domainsPlatformList = await getDomainPlatform({
      context,
      customerId: resultsFilteredBy ? customerId : null,
    });

    this.setState({ domainsPlatformList, domainIds: [] });
  }

  handleChangeDomain(values) {
    this.setState({
      domainIds: values,
    });
  }

  async onApplyFilters() {
    const {
      onApplyFilters,
      customer: { customerId },
    } = this.props;

    const { domainIds, resultsFilteredBy } = this.state;

    const { domainList, domainPlatformList } = getDomainsIdFromTree({
      domainIds,
    });

    onApplyFilters({
      domainList,
      domainPlatformList,
      customerId: resultsFilteredBy ? customerId : null,
    });
  }

  async onClearFilters() {
    const {
      context,
      customer: { customerId },
      onClearFilters,
    } = this.props;

    const { resultsFilteredBy } = this.state;

    onClearFilters();

    if (!resultsFilteredBy) {
      const domainsPlatformList = await getDomainPlatform({
        context,
        customerId: customerId,
      });

      this.setState({
        domainsPlatformList,
      });
    }

    this.setState({
      domainIds: [],
      resultsFilteredBy: true,
    });
  }

  async handleChangeFilterByCustomer({ target: { value: resultsFilteredBy } }) {
    const {
      context,
      customer: { customerId },
    } = this.props;

    const domainsPlatformList = await getDomainPlatform({
      context,
      customerId: resultsFilteredBy ? customerId : null,
    });

    this.setState({ domainsPlatformList, domainIds: [], resultsFilteredBy });
  }

  render() {
    const {
      handleChangeDomain,
      handleChangeFilterByCustomer,
      onApplyFilters,
      onClearFilters,
    } = this;

    const {
      customer: {
        name: customerName,
        tenant: { name: tenantName },
      },
    } = this.props;

    const {
      domainIds,
      domainsPlatformList,
      isEnableFilterByTenant,
      resultsFilteredBy,
    } = this.state;

    const ShowResultsFilteredBy = () => (
      <Radio
        className="rp-reported-incidents-filter-customer"
        data={[
          {
            value: true,
            text: `${translate(
              'tasks.reported_incidents.customerFilterSelector.filterByCustomerLabel'
            )} (${customerName})`,
          },
          {
            disabled: !isEnableFilterByTenant,
            value: false,
            text: `${translate(
              'tasks.reported_incidents.customerFilterSelector.filterByAllCustomersLabel'
            )} (${tenantName})`,
          },
        ]}
        defaultValue={resultsFilteredBy}
        label={translate(
          'tasks.reported_incidents.customerFilterSelector.label'
        )}
        onChange={handleChangeFilterByCustomer}
        vertical
      />
    );

    return (
      <div className="reported-incidents-container__filters">
        <Paper>
          <Row gutter={30} style={{ display: 'flex' }}>
            <Col span={8}>
              <ShowResultsFilteredBy />
            </Col>
            <Col span={8}>
              <TreeSelector
                label="Domain"
                allowClear
                treeData={domainsPlatformList}
                placeholder="All"
                onChange={handleChangeDomain}
                value={domainIds}
                dropdownStyle={{
                  maxHeight: 300,
                }}
              />
            </Col>
            <Col span={8} className="col-buttons">
              <Button type="primary" size="small" onClick={onApplyFilters}>
                {translate('tasks.reported_incidents.apply')}
              </Button>
              <Button type="secondary" size="small" onClick={onClearFilters}>
                {translate('tasks.reported_incidents.clear')}
              </Button>
            </Col>
          </Row>
        </Paper>
      </div>
    );
  }
}

ReportedIncidentsFilters.propTypes = {
  context: PropTypes.object.isRequired,
  shouldRefreshFilters: PropTypes.bool,
  onApplyFilters: PropTypes.func,
  onClearFilters: PropTypes.func,
};

ReportedIncidentsFilters.defaultProps = {
  onApplyFilters: () => {},
  onClearFilters: () => {},
  shouldRefreshFilters: false,
};

export default withContext(ReportedIncidentsFilters);
